import https from "@/utils/https";
import { ContentType, Method } from "axios-mapper";

export const getSystemHeadIcon = (request) => {
  return https().request("/system-head-icon", Method.GET, request, ContentType.form);
};
